<template>
  <v-container class="pa-0">
    <v-sheet>
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-col>
            <div class="d-flex align-start flex-column">
              <div class="px-6 mt-4">
                <div class="d-flex mb-3 align-center">
                  <div>
                    <v-img
                      src="/img/learning-resources-title.svg"
                      width="62"
                      height="62"
                      contain
                      class="flex-shrink-0 flex-grow-0"
                    />
                  </div>
                  <h1 class="ml-4">
                    {{ $t("learningResources.title") }}
                  </h1>
                </div>
              </div>
              <GenericCarousel
                :items="carouselItems"
                :item-count="5"
                :on-click="carouselOpen"
                :no-items-message="$t('learningResources.carouselEmpty')"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-row class="ma-0">
      <v-container class="pt-0">
        <v-row class="ma-0">
          <v-col class="pt-0">
            <v-list class="py-0">
              <v-subheader class="px-0 success--text">
                {{ $t("learningResources.subtitle") }}
              </v-subheader>
              <v-list-item
                v-for="(learningItem, index) in listItems"
                :key="index"
                class="px-0 mb-3"
              >
                <v-card
                  @click="openInApp(learningItem.url, learningItem.label)"
                  class="px-4 py-3 d-flex flex-grow-1 align-center"
                >
                  <div class="mr-6">
                    <v-img
                      :src="learningItem.iconUrl"
                      height="68"
                      width="68"
                    />
                  </div>
                  <div
                    style="font-size: 18px;"
                    class="font-weight-medium"
                  >
                    {{ learningItem.label }}
                  </div>
                </v-card>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import features from "@/features.json";
import { FA_BUTTON_CLICK } from "@/settings/constants";
import GenericCarousel from "@/components/GenericCarousel.vue";

const LearningResources = {
  name: "LearningResources",
  components: {
    GenericCarousel
  },
  title: "Learning resources",
  computed: {
    ...mapGetters(["mySchools"]),
    carouselItems() {
      return this.learningItems
        .filter(item => item.isFeatured)
        .map(item => ({
          title: item.label,
          link: item.url,
          image: item.imageUrl
        }));
    },
    listItems() {
      return this.learningItems
        .filter(item => !item.isHidden)
        .map(item => ({
          ...item
        }));
    }
  },
  data() {
    return {
      learningItems: []
    };
  },
  created() {
    window.addEventListener(
      "remoteConfigChanged",
      function() {
        this.learningItems = this.remoteConfig("learningResourceLinks");
      }.bind(this)
    );
  },
  mounted() {
    this.learningItems = this.remoteConfig("learningResourceLinks");
  },
  methods: {
    externalLink(link) {
      //eslint-disable-next-line
      NativeJS.debugLog(`opening external link (${link})`);
      //eslint-disable-next-line
      NativeJS.externalLink(link);
    },
    carouselOpen(item) {
      //eslint-disable-next-line
      NativeJS.debugLog(`open ${item.title}`);
      this.analytics(FA_BUTTON_CLICK, {
        item_category: "learning_resources",
        URL: item.link
      });
      this.setCookie("deeplinkType", "LEARNINGRESOURCES", 3650);
      this.setCookie("deeplinkUrl", "LEARNINGRESOURCES", 3650);
      if (parseInt(this.getCookie("appbuild")) >= features.inAppWebPage) {
        //eslint-disable-next-line
        NativeJS.debugLog("open url");
        //eslint-disable-next-line
        NativeJS.openUrl(
          item.link,
          JSON.stringify({
            title: item.title
          })
        );
      } else {
        //eslint-disable-next-line
        NativeJS.externalLink(item.link, item.title);
      }
    },
    openInApp(link, title) {
      //eslint-disable-next-line
      NativeJS.debugLog(`open ${title}`);
      this.analytics(FA_BUTTON_CLICK, {
        action: "feature_click",
        item_category: "learning_resources",
        URL: link
      });
      this.setCookie("deeplinkType", "LEARNINGRESOURCES", 3650);
      this.setCookie("deeplinkUrl", "LEARNINGRESOURCES", 3650);
      if (parseInt(this.getCookie("appbuild")) >= features.inAppWebPage) {
        //eslint-disable-next-line
        NativeJS.debugLog("open url");
        //eslint-disable-next-line
        NativeJS.openUrl(
          link,
          JSON.stringify({
            title: title
          })
        );
      } else {
        //eslint-disable-next-line
        NativeJS.externalLink(link, title);
      }
    }
  }
};

export default LearningResources;
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.125rem;
}
.v-subheader {
  font-size: 1.125rem;
  font-weight: 500;
}
.icon-button {
  border-radius: 15px !important;
  background-color: #cbedfd;
  padding: 13px 9px 14px 16px;
  &.enrolment {
    padding: 8px;
  }
}
</style>
